<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
    }
  },
  methods: {
    getUrl(url, parameter="icmp") {
      if (!url) return 'javascript:void(0)';
      if (url.includes("?")) {
        return `${url}&${parameter}=MMD`;
      } else {
        return `${url}?${parameter}=MMD`;
      }
    }
  },
  computed: {
    userTarget() {
      return globalState.pageModel?.user?.target?.[0] ?? false;
    },
    profileMenu() {
      if (!this.userTarget) {
        return this.content.menu;
      } else {
        const globalItems = this.content.navbar_items;
        const targetPageName = this.userTarget.split('target-')[1];
        const targetNavRecord = globalItems.find(item => (item.url?.content ?? {}).includes(targetPageName));

        const profileMenu = [...this.content.menu];
        profileMenu[0].button.url = targetNavRecord.url.url;
        return profileMenu;
      }
    }
  }
}

</script>

<template>
  <div class="navigation d-md-none d-flex align-items-center justify-content-center text-white text-center" navigation-menu-component>
    <a 
      v-for="link in profileMenu"
      class="navigation--link d-flex flex-column py-2" 
      :class="`col-${12/(profileMenu.length+1)}`"
      :target="getTarget(link.button)"
      :href="getUrl(link.button.url)"
    >
      <i v-if="globalState.pageModel.main_content_name == link.button.content" :class="link.icon" class="fa-solid pt-1"></i> 
      <i v-else class="fa-light pt-1" :class="link.icon"></i> 
      <span class="navigation--title pt-1">{{ link.button.title }}</span>
    </a>
    <a class="navigation--link contact d-flex flex-column py-2" :class="`col-${12/(profileMenu.length+1)}`" :href="getUrl(applyContextToUrl('/contatti-per-te'))">
      <i 
        v-if="(globalState.pageModel.main_content_name == 'page-contattaci') || ('page-contattaci' in globalState.pageModel.decorators.default)" 
        class="fa-solid fa-phone-volume flex-grow-1 pt-1">
      </i>
      <i v-else class="fa-light fa-phone-volume flex-grow-1 pt-1"></i>
      <span class="navigation--title pt-1">Contattaci</span>
    </a>
  </div>
</template>

<style lang="scss">
  $navigation-height: 3.5rem;

  body {
    @include media-breakpoint-down(md) {
      padding-bottom: calc(#{$navigation-height} - 0.1rem);
    }
  }

  .navigation {
    background-color: transparent;
    width: 100%;
    height: $navigation-height;
    position: fixed;
    bottom: 0;
    z-index: 1080;

    .contact {
      background-color: #FECB00 !important;
      color: $black !important;
    }

    .fa-light {
      font-size: 1.25rem;
    }

    &--link {
      color: $white;
      text-decoration: none;
      background-color: $primary;
    }

    &--title {
      font-size: 0.625rem;
    }
  }
</style>